export function extractApiErrorMessage(body: unknown): string | undefined {
  if (body == null) {
    return undefined;
  }

  if (typeof body !== 'object') {
    return undefined;
  }

  const record = body as Record<string, unknown>;
  const error = record['error'];
  if (error == null || typeof error !== 'object') {
    return undefined;
  }

  const message = (error as Record<string, unknown>)['message'];
  if (typeof message !== 'string') {
    return undefined;
  }

  const trimmed = message.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function extractApiErrorCode(body: unknown): string | undefined {
  if (body == null || typeof body !== 'object') {
    return undefined;
  }

  const record = body as Record<string, unknown>;
  const error = record['error'];
  if (error == null || typeof error !== 'object') {
    return undefined;
  }

  const code = (error as Record<string, unknown>)['code'];
  return typeof code === 'string' ? code : undefined;
}
